import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=f95da3ce"
import script from "./QuestionCard.vue?vue&type=script&lang=js"
export * from "./QuestionCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=f95da3ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports